import { Flex } from '@mantine/core';
import React, { useState } from 'react';
import Input from '../Inputs/Input';
import Button from '../Buttons/Button';
import { secondary } from '../../theme';
import { useGlobal } from '../../hooks/global';
import { FaRegCopy } from 'react-icons/fa';

interface CopyCheckinLinkProps {
    link: string;
    label: string;
}

const CopyCheckinLink = ({ link, label }: CopyCheckinLinkProps) => {
    const { theme, notifyBottom } = useGlobal();

    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            notifyBottom("Link copiada para área de tranferência!", "success");
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            setCopied(false);
        }
    };

    return (
        <Flex gap={22} align='end'>
            <Flex direction='column' style={{ flex: 1 }}>
                <label style={{ fontSize: '13px', marginBottom: '5px', fontWeight: 500 }}>{label}</label>
                <Input
                    name='linkCheckIn'
                    disabled={true}
                    value={link}
                />
            </Flex>

            <Button
                onClick={handleCopy}
                background={secondary[theme]}
                color={"#FFF"}
                style={{ padding: 8, maxWidth: 80, maxHeight: 38, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1px' }}
                children={<FaRegCopy size={20} />}
                disabled={copied}
            />
        </Flex>

    );
};

export default CopyCheckinLink;